// Elevar Data Layer Hooks
// Easy imports for all Elevar tracking functionality

// Types
export * from './types';

// Utilities
export * from './utils';

// Base hooks
export { default as useElevarUserData } from './useElevarUserData';
export { default as useElevarProductView } from './useElevarProductView';
export { default as useElevarViewCart } from './useElevarViewCart';

// Product interaction handlers
export {
  handleElevarAddToCart,
  handleElevarAddToCartMultiple
} from './useElevarAddToCart';

export {
  handleElevarRemoveFromCart
} from './useElevarRemoveFromCart';

// Collection and search
export {
  useElevarViewItemList,
  useElevarViewSearchResults,
  handleElevarSelectItem
} from './useElevarItemList';

// Auth events
export {
  handleElevarSignUp,
  handleElevarLogin
} from './useElevarAuth';

// Newsletter subscription events
export {
  handleElevarEmailSubscribe,
  handleElevarPhoneSubscribe,
  handleElevarCombinedSubscribe,
  handleElevarSubscribe
} from './useElevarSubscribe';

// Re-export key utilities for convenience
export {
  initializeElevarDataLayer,
  invalidateElevarContext,
  setReferrerList,
  clearReferrerList
} from './utils';